export const c_form_control_m_icon_invalid_BackgroundPosition = {
  "name": "--pf-c-form-control--m-icon--invalid--BackgroundPosition",
  "value": "calc(100% - 0.5rem) center, calc(calc(100% - 0.5rem) - 0.5rem - 1rem) center",
  "var": "var(--pf-c-form-control--m-icon--invalid--BackgroundPosition)"
};
export default c_form_control_m_icon_invalid_BackgroundPosition;